import { useCallback } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useOkapiKy } from "@folio/stripes/core";
import { changePeriodicalLibraryStatus } from "../api/periodicalLibraryService";
import { PeriodicalLibraryStatusEnum } from "../types/Api";
export var useNewPeriodicalActions = function () {
    var kyInstance = useOkapiKy();
    var queryClient = useQueryClient();
    var invalidate = useCallback(function () { return queryClient.invalidateQueries(["periodicalLibraries"]); }, [queryClient]);
    var subscribeMutation = useMutation(function (id) {
        return changePeriodicalLibraryStatus(kyInstance, id, {
            status: PeriodicalLibraryStatusEnum.SUBSCRIBED,
        });
    }, { onSuccess: invalidate });
    var excludeMutation = useMutation(function (_a) {
        var id = _a.id, reason = _a.reason, note = _a.note;
        return changePeriodicalLibraryStatus(kyInstance, id, {
            status: PeriodicalLibraryStatusEnum.EXCLUDED,
            reason: reason,
            note: note,
        });
    }, { onSuccess: invalidate });
    return {
        handleSubscribe: subscribeMutation.mutate,
        handleExclude: excludeMutation.mutate,
        isSubscribing: subscribeMutation.isLoading,
        isExcluding: excludeMutation.isLoading,
    };
};
